import { BaseEntity } from "../base-entity";
import { BreezeModelBuilder } from "../breeze-model-builder";
import { Organisation } from "./organisation";
import { Team } from "./team";

export class VisionCategory extends BaseEntity<VisionCategory> {
    public visionCategoryId!: number;
    public name!: string;
    public description!: string;
    public descriptionSlug!: string;
    public ordinal!: number;
    public organisationId!: number;
    public teamId!: number;

    public organisation!: Organisation;
    public team!: Team;
}

export const VisionCategoryBreezeModel = new BreezeModelBuilder("VisionCategory", VisionCategory)
    .hasSource("VisionCategories")
    .withIdField()
    .orderBy("ordinal")
    .isOrganisationEntity()
    .build();
